import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Confirmations } from '../../enums/confirmation';
import * as Actions from '../../store/csw/csw.actions';

export const useShippingServiceState = (
  fulfillmentPlanId,
  onConfirmationChange,
  onServiceChangeUpdateOtherShippingOptions,
  onConfigurationChange,
) => {
  const dispatch = useDispatch();

  const updateOtherShippingOptionsAndCustomsCheck = useCallback(
    (shippingServiceId, sellerLabelProviderId, confirmationId) => {
      const targetServiceId = shippingServiceId?.toString();
      const targetSellerLabelProviderId = sellerLabelProviderId?.toString();
      dispatch(Actions.updateServiceAndOtherShippingOptions(fulfillmentPlanId, targetServiceId, targetSellerLabelProviderId));
      onServiceChangeUpdateOtherShippingOptions(shippingServiceId, confirmationId);
    },
    [dispatch, fulfillmentPlanId, onServiceChangeUpdateOtherShippingOptions],
  );

  const onServiceChange = useCallback(
    ({
      serviceId,
      sellerLabelProviderId,
      serviceCollectionGuid: newServiceCollectionGuid,
      confirmationId = `${Confirmations.NoConfirmation.ordinal}`,
      sendAnalytics,
    }) => {
      if (newServiceCollectionGuid) {
        dispatch(Actions.updateServiceAndOtherShippingOptions(fulfillmentPlanId));
        dispatch(
          Actions.updateShipmentConfiguration(fulfillmentPlanId, {
            serviceCollectionGuid: newServiceCollectionGuid,
          }),
        );
        const updatedOptions = onConfirmationChange(confirmationId);
        onConfigurationChange(
          {
            options: updatedOptions,
            serviceId: null,
            sellerLabelProviderId: null,
            serviceCollectionGuid: newServiceCollectionGuid,
          },
          {},
          sendAnalytics,
        );
        return;
      }

      // else, normal sellerLabelProvider path
      onConfigurationChange(
        {
          serviceId,
          sellerLabelProviderId,
          serviceCollectionGuid: newServiceCollectionGuid,
        },
        {
          shouldUpdateNeedsCustoms: true,
        },
        sendAnalytics,
      );
      dispatch(
        Actions.updateShipmentConfiguration(fulfillmentPlanId, {
          serviceCollectionGuid: undefined,
        }),
      );
      updateOtherShippingOptionsAndCustomsCheck(serviceId, sellerLabelProviderId, confirmationId);
    },
    [dispatch, updateOtherShippingOptionsAndCustomsCheck, fulfillmentPlanId, onConfirmationChange, onConfigurationChange],
  );

  const onSellerLabelProviderChange = useCallback(
    (newSellerLabelProviderId) => {
      onConfigurationChange(
        {
          sellerLabelProviderId: newSellerLabelProviderId,
        },
        {
          shouldUpdateNeedsCustoms: true,
        },
      );
      dispatch(
        Actions.updateShipmentConfiguration(fulfillmentPlanId, {
          sellerLabelProviderId: newSellerLabelProviderId,
        }),
      );
    },
    [dispatch, fulfillmentPlanId, onConfigurationChange],
  );

  return {
    onSellerLabelProviderChange,
    onServiceChange,
  };
};
